export default (entity = {}) => {
    return {
        id: entity.id || undefined,
        name: entity.name || '',
        description: entity.description || '',
    };
};